import { Button } from "@mui/material";
import "./styles/ReportNav.css";
import { AutoStoriesRounded } from "@mui/icons-material";
const LocalNav = ({ examName }) => {
  function launchRegister() {
    window.open("/register", "_self");
  }

  return (
    <nav>
      <ul className="report-nav">
        <li>
          <div>
            <AutoStoriesRounded color="iconGray" />
          </div>
          <div>
            <h4 className="mb-0 ellipsis">{examName}</h4>
            <small className="mb-0">Evaluation Report</small>
          </div>
        </li>
        <Button
          size="small"
          className="px-4 py-2"
          style={{
            background: "var(--blueGradient)",
          }}
          variant="contained"
          disableElevation
          onClick={launchRegister}
        >
          Sign Up
        </Button>
      </ul>
    </nav>
  );
};

export default LocalNav;
